// extracted by mini-css-extract-plugin
export var logo = "header-logo-link-module--logo--Nn8Db";
export var logoLink = "header-logo-link-module--logoLink--rzLoM";